import type { AvailabilitySlot, HoldResponse, Locale } from '@seaa/shared'
import type { AvailabilityServiceSummary } from '@seaa/shared/contracts'

/** Search parameters are hints; only the venue's returned services can be selected. */
export function bookingSearch(search: Record<string, unknown>): { lang?: Locale | undefined; serviceId?: string | undefined } {
  const serviceId = search.serviceId ?? search.service
  return {
    lang: typeof search.lang === 'string' && ['ar', 'en', 'de', 'nl'].includes(search.lang) ? search.lang as Locale : undefined,
    serviceId: typeof serviceId === 'string' && serviceId.length <= 100 ? serviceId : undefined,
  }
}

export function initialService(services: AvailabilityServiceSummary[], requested?: string, previous?: string | null) {
  return services.find((service) => service.id === requested)
    ?? services.find((service) => service.id === previous)
    ?? services[0]
}

export function resumableHold(slug: string, previousSlug: string, hold: HoldResponse | null, now: string) {
  return slug === previousSlug && hold && Date.parse(hold.expiresAt) > Date.parse(now) ? hold : null
}

/** A refetch must refresh price/capacity, not preserve an obsolete slot object. */
export function refreshedSelection(slots: AvailabilitySlot[], selected: AvailabilitySlot | null) {
  if (!selected) return null
  return slots.find((slot) => slot.available && sameSlot(slot, selected)) ?? null
}

export function sameSlot(left: AvailabilitySlot | null, right: AvailabilitySlot | null) {
  return Boolean(left && right && left.resourceId === right.resourceId
    && left.serviceId === right.serviceId && left.startsAt === right.startsAt
    && left.endsAt === right.endsAt && (left.durationOptionId ?? null) === (right.durationOptionId ?? null))
}
